import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';

export const CompanyTypeQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            label={
                <FormattedMessage
                    id="_.your_company.company_type"
                    defaultMessage="Company type"
                />
            }
            name="companyType"
            id="companyType"
            onChangeHandler={onChange}
            disabled={true}
        />
    );
};
